/*global module: false */
'use strict';

// Configure the primary key for the tsv table here, for use in the
// webpack dsv loader and the client code.

module.exports = ['id'];



// WEBPACK FOOTER //
// ./databaseKey.js